import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Only import the fallback language statically (for instant render).
// All other languages are loaded dynamically on demand.
import es from './locales/es.json';

const loadLocale = async (lang: string) => {
    switch (lang) {
        case 'en': return (await import('./locales/en.json')).default;
        case 'fr': return (await import('./locales/fr.json')).default;
        case 'de': return (await import('./locales/de.json')).default;
        case 'it': return (await import('./locales/it.json')).default;
        case 'pt': return (await import('./locales/pt.json')).default;
        default: return null;
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            es: { translation: es },
        },
        fallbackLng: 'es',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
            lookupQuerystring: 'lang',
            caches: ['localStorage'],
        },
    });

// After init, dynamically load the detected language if it's not 'es'
const detectedLang = i18n.language?.substring(0, 2);
if (detectedLang && detectedLang !== 'es') {
    loadLocale(detectedLang).then(translations => {
        if (translations) {
            i18n.addResourceBundle(detectedLang, 'translation', translations, true, true);
            i18n.changeLanguage(detectedLang);
        }
    });
}

// Hook into language changes to load translations on demand
i18n.on('languageChanged', async (lng) => {
    const lang = lng.substring(0, 2);
    if (lang !== 'es' && !i18n.hasResourceBundle(lang, 'translation')) {
        const translations = await loadLocale(lang);
        if (translations) {
            i18n.addResourceBundle(lang, 'translation', translations, true, true);
            // Force re-render with new translations
            i18n.changeLanguage(lang);
        }
    }
});

export default i18n;
